import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error:', error)
    console.error('Error info:', errorInfo)
    console.error('Error stack:', error.stack)
    console.error('Component stack:', errorInfo.componentStack)

    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    const { hasError, error, errorInfo } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h2>Something went wrong with this component.</h2>
          <details
            style={{
              whiteSpace: 'pre-wrap',
              marginTop: '10px'
            }}
          >
            <summary>Error Details</summary>
            <div style={{ marginTop: '10px' }}>
              <strong>Error:</strong>
              <pre>{error && error.toString()}</pre>
            </div>
            <div style={{ marginTop: '10px' }}>
              <strong>Component Stack:</strong>
              <pre>{errorInfo && errorInfo.componentStack}</pre>
            </div>
          </details>
        </div>
      )
    }
    return children
  }
}

export default ErrorBoundary
